import "./homepage.styles.scss"
import Navbar from "../../navbar/navbar.component"
import Opener from "../../components/opener/opener.component"
import Footer from "../../components/footer/footer.component"
import LearnerTutorCreator from "../../components/learnertutorcreator/learnertutorcreator.component"
import Learner from "../../assets/homepage/Learner.png"
import Tutor from "../../assets/homepage/Tutor.png"
import Creator from "../../assets/homepage/Creator.png"
import LearnerHero from "../../assets/homepage/phone2.png"
import TutorHero from "../../assets/homepage/request.png"
import CreatorHero from "../../assets/homepage/creator_hero3.png"
import Roadmap from "../../components/roadmap/roadmap.component"

function Homepage() {
  return (
    <div className="homepage-wrapper">
      <div className="content-wrapper">
        <Navbar />
        <section>
          <Opener
            link_title1="Sign up for tutoring"
            link1="/tutoring"
            link_title2="Sign up for free our learning platform"
            link2="https://platform.educationequation.co.uk/signup"
          />
        </section>
        <section id="learner" className="no-back">
          <LearnerTutorCreator
            headline="Learn anything with our free high quality courses"
            text="Access courses from world renowned experts on everything from education to career and much more"
            benefits={[
              {
                one: "Free access to 1000s of courses",
                two: "Creators are rewarded to post high quality learning content",
              },
              {
                one: "Mastery learning rating system",
                two: "All courses are automatically built with traffic light self assessments and progress overview",
              },
              {
                one: "On demand help from experts",
                two: "Learners get bespoke help within 5 minutes if they are stuck on any section",
              },
            ]}
            bow_image={Learner}
            hero_image={LearnerHero}
          />
        </section>
        <section id="tutor" className="no-back">
          <LearnerTutorCreator
            headline="Earn money on demand"
            text=""
            benefits={[
              {
                one: "100% Flexible",
                two: "Tutors don’t need to commit for months of lessons; log on whenever it is convenient!",
              },

              {
                one: "Data driven selling",
                two: "Tutors know exactly what topics the learner  is struggling on and which course, so can tailor their sell",
              },
              {
                one: "Larger pool of learners",
                two: "Courses creates natural SEO bringing in new clients who wouldn’t have searched for tutors otherwise",
              },
              {
                one: "Lower commissionless",
                two: "EdEqTutor only has a 10% commission rate",
              },
            ]}
            bow_image={Tutor}
            hero_image={TutorHero}
            hero_image_styles={{
              border: "1px solid black",
              borderRadius: "20px",
              width: "90%",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            }}
            reversed={true}
          />
        </section>
        <section id="creator" className="no-back">
          <LearnerTutorCreator
            headline="Get paid for every interaction your course receives"
            text="A month from now, a year or even 5 years from now, if people are still using your course, we will reward you with tokens!"
            benefits={[
              {
                one: "Zero commission rewards",
                two: "Creators keep 100% of their rewards in EdEqTokens every single week",
              },
              {
                one: "Power in the hands of creators",
                two: "Popular content cannot be demonetized by advertisers or third parties",
              },
            ]}
            bow_image={Creator}
            hero_image={CreatorHero}
            hero_image_styles={{
              border: "1px solid black",
              borderRadius: "20px",
              width: "85%",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            }}
          />
        </section>
        {/* <section id="founder">
          <FounderStory />
        </section> */}
        {/* <section id="problem">
          <Problem />
        </section> */}
        {/* <section id="demo">
          <ProductDemo />
        </section> */}
        <section className="no-back">
          <Roadmap />
        </section>
      </div>
      <Footer id="contact" />
    </div>
  )
}

export default Homepage
